import { render, staticRenderFns } from "./HazardClassView.vue?vue&type=template&id=36c29f8c&"
import script from "./HazardClassView.vue?vue&type=script&lang=js&"
export * from "./HazardClassView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports